import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=e409f58c&scoped=true&lang=pug&"
import script from "./prefectures.vue?vue&type=script&lang=js&"
export * from "./prefectures.vue?vue&type=script&lang=js&"
import style0 from "./prefectures.vue?vue&type=style&index=0&id=e409f58c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e409f58c",
  null
  
)

export default component.exports